import React from "react";

import "./ProfileHeader.css";
import { Icon } from "../../Icon/Icon";
import { useTranslation } from "react-i18next";

export const ProfileHeader = ({ name = " " }) => {
  const { t } = useTranslation();
  return (
    <div className="ProfileHeader">
      <div className="ProfileHeader__image">
        <Icon name="iconEmployee" width={40} height={40} />
      </div>
      <div className="ProfileHeader__text">
        <div className="ProfileHeader__text--static">
          {t("profile.myProfile")}
        </div>
        <div className="ProfileHeader__text--name">{name}</div>
      </div>
    </div>
  );
};
